module.exports = __webpack_public_path__ + "img/img-34.a59a7f27.png";